import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiFragment } from '../../../entities/api-fragment.entity';
import { StukCount } from '../../../entities/stuk-count.entity';
import { BaseColumnComponent } from '../../../services/base-column-component';
import { StukCountService } from '../../../services/stuk-count.service';

/**
 * HFBD-7a: the `Aantal stukken` column on a dossier row — how many stukken it holds, without expanding it.
 *
 * The cell fetches nothing itself: {@link StukCountService} counts a whole page of dossiers in two requests
 * and this reads the answer, so 25 dossiers still cost two lookups rather than 25.
 */
@Component({
    standalone: false,
    selector: 'digihaven-stuk-count-cell',
    templateUrl: './stuk-count-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StukCountCellComponent extends BaseColumnComponent<ApiFragment> {
    count$: Observable<StukCount>;

    constructor(countService: StukCountService, cd: ChangeDetectorRef) {
        super(cd);

        this.count$ = this.data$.pipe(switchMap(record => countService.countFor(record.getId())));
    }
}
